import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './destroyPopMutation.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type DestroyPopMutation_destroyPop_MenuItem_userPop_Pop = {
  __typename: 'Pop',
  id: number,
  popType: string
};

export type DestroyPopMutation_destroyPop_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  popsCount: number,
  userPop?: DestroyPopMutation_destroyPop_MenuItem_userPop_Pop | null
};

export type DestroyPopMutation_Mutation = {
  __typename?: 'Mutation',
  destroyPop: DestroyPopMutation_destroyPop_MenuItem
};


export type DestroyPopMutationVariables = Types.Exact<{
  menuItemId: Types.Scalars['Int']['input'];
}>;


export type DestroyPopMutation = DestroyPopMutation_Mutation;


export const DestroyPopDocument = /*#__PURE__*/ document as unknown as DocumentNode<DestroyPopMutation, DestroyPopMutationVariables>;

export type DestroyPopMutationFn = ApolloReactCommon.MutationFunction<DestroyPopMutation, DestroyPopMutationVariables>;

/**
 * __useDestroyPopMutation__
 *
 * To run a mutation, you first call `useDestroyPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyPopMutation, { data, loading, error }] = useDestroyPopMutation({
 *   variables: {
 *      menuItemId: // value for 'menuItemId'
 *   },
 * });
 */
export function useDestroyPopMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyPopMutation, DestroyPopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyPopMutation, DestroyPopMutationVariables>(DestroyPopDocument, options);
      }
export type DestroyPopMutationHookResult = ReturnType<typeof useDestroyPopMutation>;
export type DestroyPopMutationResult = ApolloReactCommon.MutationResult<DestroyPopMutation>;
export type DestroyPopMutationOptions = ApolloReactCommon.BaseMutationOptions<DestroyPopMutation, DestroyPopMutationVariables>;